import { IconButtonProps, IconButton as MuiIconButton, TypeText, styled } from '@mui/material';

interface IIconButton extends IconButtonProps {
  // https://github.com/mui/material-ui/issues/31194
  component?: React.ElementType;
  to?: string;
}

export const NavButton = styled(MuiIconButton)<IIconButton>((props) => {
  const { color = 'secondary', theme: { palette: { text } } } = props;
  return {
    padding: '0',
    position: 'relative',
    svg: {
      fontSize: 16,
      position: 'absolute',
    },
    path: {
      fill: '#FFF',
    },
    ':before': {
      content: '""',
      borderRadius: '50%',
      padding: '24px',
      background: text[color as unknown as keyof TypeText],
    },
  };
});
